import App from './App.svelte';

window.addEventListener('unhandledrejection', (e) => {
  const err = e.reason instanceof Error ? e.reason : new Error(String(e.reason));
  // Filter expected media aborts to reduce noise
  if (err.name === 'AbortError' || err.name === 'NotAllowedError') return;
  if (window.TrackJS) window.TrackJS.track(err);
  else console.error('Unhandled rejection:', err);
});

var app = new App({
	target: document.querySelector('#app')
});

export default app;